module.exports = __webpack_public_path__ + "img/employee-1.d8692113.jpeg";